// Google fonts
import Fonts from 'google-fonts';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core';

// Solids Icons
import {
  faAnchor,
  faArchway,
  faArrowsAltV,
  faAward,
  faBook,
  faCamera,
  faCalendar,
  faChartBar,
  faChartLine,
  faCheckCircle,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleNotch,
  faCog,
  faCreditCard,
  faDiceFive,
  faDownload,
  faEdit,
  faEllipsisV,
  faEnvelope,
  faExclamationTriangle,
  faExclamationCircle,
  faGem,
  faFilm,
  faFilter,
  faGlobeAmericas,
  faList,
  faHome,
  faImage,
  faImages,
  faMap,
  faMapMarker,
  faMapMarkerAlt,
  faMinus,
  faPrint,
  faPlay,
  faPlus,
  faQuestionCircle,
  faShareAlt,
  faSpinner,
  faSquare,
  faSyncAlt,
  faTag,
  faTimes,
  faToolbox,
  faTrash,
  faTrophy,
  faUndo,
  faUser,
  faUsers,

  // Icon Picker Icons
  faCertificate,
  faRibbon,
  faCircle,
  faHeart,
  faBookmark,
  faStar,

  faShoePrints,
  faChild,
  faHandLizard,
  faHandPaper,
  faHandRock,
  faHandSpock,

  faArrowUp,
  faArrowDown,
  faDove,
  faDumbbell,
  faBrain,
  faBomb,

  faScrewdriver,
  faCommentDots,
  faClock,
  faBug,
  faCheck,
  faBolt,  
} from '@fortawesome/free-solid-svg-icons';

// Regular Icons
import {
  faClock as faClockRegular,
  faImage as faImageRegular,
  faSquare as faSquareRegular,
  faUser as faUserRegular,
  faEnvelope as FaEnveloperRegular,
} from '@fortawesome/free-regular-svg-icons';

// Load Fonts
library.add(
  faAnchor,
  faArchway,
  faArrowsAltV,
  faAward,
  faBook,
  faCamera,
  faCalendar,
  faChartBar,
  faChartLine,
  faCheckCircle,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleNotch,
  faClockRegular,
  faCog,
  faCreditCard,
  faDiceFive,
  faDownload,
  faEdit,
  faEllipsisV,
  faEnvelope,
  FaEnveloperRegular,
  faExclamationCircle,
  faExclamationTriangle,
  faFilm,
  faFilter,
  faGem,
  faGlobeAmericas,
  faList,
  faHome,
  faImage,
  faImageRegular,
  faImages,
  faQuestionCircle,
  faMap,
  faMapMarker,
  faMapMarkerAlt,
  faMinus,
  faPlay,
  faPlus,
  faPrint,
  faQuestionCircle,
  faShareAlt,
  faSpinner,
  faSquare,
  faSquareRegular,
  faSyncAlt,
  faTag,
  faTimes,
  faToolbox,
  faTrash,
  faTrophy,
  faUndo,
  faUser,
  faUserRegular,
  faUsers,

  // Icon Picker Icons
  faCertificate,
  faRibbon,
  faCircle,
  faHeart,
  faBookmark,
  faStar,

  faShoePrints,
  faChild,
  faHandLizard,
  faHandPaper,
  faHandRock,
  faHandSpock,

  faArrowUp,
  faArrowDown,
  faDove,
  faDumbbell,
  faBrain,
  faBomb,

  faScrewdriver,
  faCommentDots,
  faClock,
  faBug,
  faCheck,
  faBolt,  
);
Fonts.add({
  Raleway: ['400', '500', '700'],
  'Yanone Kaffeesatz': ['300', '400', '700'],
  Inter: ['400', '500', '700'],
});
